import { DEFAULT_CURRENCY } from '@/api/rest/resources/types/currency';
import { useUserContext } from '@/lib/auth';

export const useDefaultCurrency = () => {
  const { user } = useUserContext();
  return user?.membership?.organization?.currency_code ?? DEFAULT_CURRENCY;
};
